import { TEntityOverride } from 'src/types'
import { TEntityUntagged } from '@obvious.tech/constellation/Entity'

const override = {
  titleField: 'name',
  global: {
    properties: {
      id: {
        displayedName: 'ID',
      },
      groups: {
        displayedName: 'Owners',
        type: 'groups',
      },
      name: {
        displayedName: 'Name',
      },
      imageId: {
        displayedName: 'Map Background Image',
        reference: {
          target: 'Image',
          targetLabelKeyPath: 'name',
        },
      },
      group: {
        displayedName: 'Group',
      },
      order: {
        displayedName: 'Order',
      },
      displayName: {
        displayedName: 'Display Name',
      },
      creationDate: {
        displayedName: 'Creation Date',
      },
      lastEditDate: {
        displayedName: 'Modification Date',
      },
      author: {
        displayedName: 'Author',
        type: 'object',
        reference: {
          target: 'Passport',
          targetIdKeyPath: 'id',
          targetLabelKeyPath: 'username',
          idKeyPath: 'passportId',
          labelKeyPath: 'userName',
        },
        readOnly: true,
      },
      creatorId: {
        // field is deprecated and awaiting removal, replaced with 'author'
        hidden: true,
      },
      file: {
        // hidden because file uploads are currently not implement for this case
        // TODO: implement in `addUploadFeature` and un-hide
        hidden: true,
        displayedName: 'Icon Image',
        type: 'Image',
      },
    },
  },
} satisfies TEntityOverride<TEntityUntagged<'Layer'>>

export default override
